export const testimonialsData = [
  {
    id: 1,
    name: 'Kenneth Paniagua',
    role: {
      en: 'Coach, He was a coordinator for the youth leagues and later as my coach.',
      es: 'Entrenador, fue coordinador de las ligas juveniles y luego mi entrenador.'
    },
    image: '/dt1.jpeg',
  },
  {
    id: 2,
    name: 'Pablo Salazar',
    role: {
      en: 'Pablo was my coach at the end of the 2022-2023 season and at the beginning of the 2023-2024 season.',
      es: 'Pablo fue mi entrenador al final de la temporada 2022-2023 y al comienzo de la temporada 2023-2024.'
    },
    image: '/dt2.jpg',
  },
  {
    id: 3,
    name: 'Breansse Camacho',
    role: {
      en: 'Former coach of Costa Rica’s U20 team, leading them to a World Cup.',
      es: 'Ex entrenador de la selección Sub-20 de Costa Rica, llevándolos a un Mundial.'
    },
    image: '/dt3.jpg',
  },
  {
    id: 4,
    name: 'Jewison Bennette',
    role: {
      en: 'He is currently the assistant coach of the first team at Club Sport Herediano. He was my coach at certain times during the 2023-2024 season',
      es: 'Actualmente es el entrenador asistente del primer equipo del Club Sport Herediano. Fue mi entrenador en ciertos momentos durante la temporada 2023-2024'
    },
    image: '/dt4.avif',
  },
  {
    id: 5,
    name: 'Manfred Schumann',
    role: {
      en: 'Manfred was my coach for most of the 2023-2024 season',
      es: 'Manfred fue mi entrenador durante la mayor parte de la temporada 2023-2024'
    },
    image: '/dt5.jpg',
  },
  {
    id: 6,
    name: 'Bob Reasso',
    role: {
      en: 'He was my coach at combine academy',
      es: 'Fue mi entrenador en la academia Combine'
    },
    image: '/dt6.webp',
  },
];
